export enum SETTING_KEY {
  USER = 'User',
  TASK = 'Task',
  TOOL = 'Tool',
  AI_TOOL = 'AiTool',
  YUSHENG_TOOL = 'yushengTool',
}
